import { connect } from "react-redux"
import React from "react"

import type { Role } from "../../types/types"
import ContentLoaderLines from "./content-loading/ContentLoaderLines"
import StakeholderRelationshipViewRoleBlock from "./StakeholderRelationshipViewRoleBlock"

type Props = {
    isFetching: boolean,
    roles: Array<Role>
}

const StakeholderRelationshipsViewWidget = ({ isFetching, roles }: Props) => (
    <div className="widget">
        <h3 className="widget-header">
            <i className="icon icon-concepts" />Relationships
        </h3>
        <div className="widget-content">
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={2}
                maxLines={5}
            >
                {roles.length > 0 &&
                    roles.map((role, index) => (
                        <StakeholderRelationshipViewRoleBlock
                            key={role.id || index}
                            role={role}
                        />
                    ))}
            </ContentLoaderLines>
        </div>
    </div>
)

const mapStateToProps = ({ presentation: { roles }, entities }) => ({
    roles: roles.view.map(role => entities.roles[role])
})

export default connect(mapStateToProps)(StakeholderRelationshipsViewWidget)
